import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useMediaQuery } from 'react-responsive'
import { FormattedMessage } from 'react-intl'
import history from 'src/history'

// Actions
import { toggleAuthModal } from 'src/actions/homeSearchAuthModal'

// Components
import { Button } from 'src/Components'
import Logo from 'src/Components/shared/Logo'
import AgentDropdown from 'src/App/Layout/Header/AgentDropdown'
import Header from 'src/Components/shared/Header'

// Selectors
import { selectActiveTab } from 'src/store/selectors/navigation'
import {
  selectClientHomesCount,
  selectClientIsGuest,
} from 'src/store/selectors/client'
import { selectHomeId } from 'src/store/selectors/home/refinance'
import { selectIsSoloRea } from 'src/store/selectors/customerProfile'
import { selectNavbarLoading } from 'src/store/selectors/display'

// Utils
import { mapActiveTabToActiveDropdownItem } from 'src/constants/navigation'
import { onHomeDigestPath, onHomeSearchPath } from 'src/helpers/routes'
import { getCurrentPath } from 'src/helpers/browser'

// NavLinks
import YourHome from './Header/Links/YourHome'
import FindAHome from './Header/Links/FindAHome'

// Styles
import styles from './AppHeader.module.scss'

const AppHeader = ({ enableAgentDropdown, ...restProps }) => {
  const dispatch = useDispatch()
  const isMediumScreen = useMediaQuery({ query: '(min-width: 500px)' })
  const size = isMediumScreen ? 'medium' : 'small'

  // TODO:: Maybe clean up/move to selector
  const homesCount = useSelector(selectClientHomesCount)
  const navbarLoading = useSelector(selectNavbarLoading)
  const currentPath = getCurrentPath()
  const isOnHomeDigestPath = onHomeDigestPath(currentPath)

  const disabled = homesCount > 1 && navbarLoading && isOnHomeDigestPath

  const activeTab = useSelector(selectActiveTab)
  const activeHomeId = useSelector(selectHomeId)
  const activeDropdownItem = mapActiveTabToActiveDropdownItem(
    activeTab,
    activeHomeId
  )

  const isSoloRea = useSelector(selectIsSoloRea)
  const isGuest = useSelector(selectClientIsGuest)

  const handleGuestClick = () => {
    if (onHomeSearchPath(getCurrentPath())) {
      history.push(`?redirectUrl=${window.location.href}`)
    }

    dispatch(toggleAuthModal(true))
  }

  return (
    <Header {...restProps}>
      <Header.Content>
        <Logo className={styles.logo} />
        <div className={styles.navigation}>
          <div className={styles.tab}>
            <YourHome
              disabled={disabled}
              activeDropdownItem={activeDropdownItem}
              size={size}
            />
          </div>
          {!isSoloRea && (
            <div className={styles.tab}>
              <FindAHome activeDropdownItem={activeDropdownItem} size={size} />
            </div>
          )}
        </div>
        <div className={styles.actions}>
          {isGuest && (
            <Button
              id='signUpBtn'
              className={styles.signUp}
              onClick={handleGuestClick}
            >
              <FormattedMessage
                data-qa='signUpBtn'
                id='Navbar.signUp.cta'
                defaultMessage='Sign up'
              />
            </Button>
          )}
          {enableAgentDropdown && (
            <AgentDropdown className={styles.agentDropdown} />
          )}
        </div>
      </Header.Content>
    </Header>
  )
}

AppHeader.propTypes = {
  enableAgentDropdown: PropTypes.bool,
}

export default AppHeader
